import React, { useContext } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import PendingExams from './exams/PendingExams.js';
import FinishedByMeExams from './exams/FinishedByMeExams.js';
import Trainers from './Trainers.js';
import Admins from './Admins.js';
import Clients from './Clients.js';
import Profile from './Profile.js';
import Login from './Login.js';
import Register from './Register.js';

import { AuthContext } from '../contexts/AuthContext.js';
import TrainerContextProvider from '../contexts/TrainerContext.js';


export default () => {
  const { isAuthAdmin, isAuthTrainerOrAdmin } = useContext(AuthContext);
  return (
    <BrowserRouter>
      <Switch>
	{ isAuthTrainerOrAdmin() && <Route exact path='/'
					   render={props => <TrainerContextProvider><PendingExams {...props}/></TrainerContextProvider>}/> }
	{ isAuthTrainerOrAdmin() && <Route exact
					   path='/finished'
					   render={props => <TrainerContextProvider><FinishedByMeExams {...props}/></TrainerContextProvider>}/> }
	{ isAuthAdmin() && <Route path='/trainers'
				  render={props => <TrainerContextProvider><Trainers {...props}/></TrainerContextProvider>}/> }
	{ isAuthAdmin() && <Route path='/admins'
				  render={props => <TrainerContextProvider><Admins {...props}/></TrainerContextProvider>}/> }
	{ isAuthTrainerOrAdmin() && <Route path='/profile'
					   render={props => <TrainerContextProvider><Profile {...props}/></TrainerContextProvider>}/> }
	{ isAuthTrainerOrAdmin() && <Route path='/clients'
					   render={props => <TrainerContextProvider><Clients {...props}/></TrainerContextProvider>}/> }
	{ isAuthTrainerOrAdmin() && <Redirect to={{pathname: '/'}}/>}
	<Route exact path='/' component={Login}/>
	<Route path='/login' component={Login}/>
	<Route path='/register' component={Register}/>
	<Redirect to={{pathname: '/'}}/>
	{/* <Route component={Nada} /> */}
      </Switch>
    </BrowserRouter>
  );
};
